interface QuoteNotesProps {
  notes: string;
}

const QuoteNotes = ({ notes }: QuoteNotesProps) => {
  if (!notes || notes.trim() === '') {
    return null;
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <h2 className="text-lg font-semibold text-text-primary mb-4">Additional Notes</h2>
      <div className="prose prose-sm max-w-none">
        <p className="text-sm text-text-primary whitespace-pre-wrap leading-relaxed">
          {notes}
        </p>
      </div>
    </div>
  );
};

export default QuoteNotes;